import React from 'react';
import ErrorPage from './ErrorPage';
import { func, shape, string } from 'prop-types';
import useStandardErrorButtons from './useStandardErrorButtons';

export default function NetworkErrorPage({ onClickReset, error }) {
  const buttons = useStandardErrorButtons(onClickReset);
  return <ErrorPage message={error.message} buttons={buttons} />;
}

NetworkErrorPage.propTypes = {
  onClickReset: func,
  error: shape({ message: string }),
};
